import { forwardRef, Injectable } from '@angular/core'
import { UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { ScrollHelperService } from '@se-po/shared-data-access-helpers'
import { AnalyticsService, UserDuplicateLookupService } from '@se-po/shared-data-access-services'
import { first } from 'rxjs/operators'
import { SeFeFormService } from 'se-fe-form-service'
import { UserServiceResources as us } from 'se-resource-types'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => ParentGuardianInfoSubmitService),
  deps: [Router]
})
export abstract class ParentGuardianInfoSubmitter {
  public abstract submitting: boolean
  public abstract matchingDupe: us.UserDuplicateLookupResult
  public abstract matchingEmail: string
  public abstract submit(form: UntypedFormGroup, store: StoreService): void
  public abstract emailMatchSignIn(emailMatchSignIn: HTMLFormElement): void
  public abstract validateAndSubmit(form: UntypedFormGroup, store: StoreService): void
}

@Injectable({
  providedIn: 'root'
})
export class ParentGuardianInfoSubmitService implements ParentGuardianInfoSubmitter {
  public submitting = false
  public matchingEmail: string
  public matchingDupe: us.UserDuplicateLookupResult

  constructor(
    private analyticsService: AnalyticsService,
    private dupeService: UserDuplicateLookupService,
    private formService: SeFeFormService,
    public router: Router,
    private scrollHelper: ScrollHelperService,
  ) {}

  public validateAndSubmit(form: UntypedFormGroup, store: StoreService): void {
    this.submitting = true
    if (!this.formService.isValid(form)) {
      this.submitting = false
      this.analyticsService.trackFormErrors(form)
      return
    }
    this.submit(form, store)
  }

  public submit(form: UntypedFormGroup, store: StoreService): void {
    this.analyticsService.seEvent('ContinueToSignUpClick')
    store.accountInfo = form.value
    this.dupeService.search(store.userDuplicateLookupParams)
      .pipe(first())
      .subscribe((result) => {
        store.dupes = result
        if (!result) return this.next(store)

        else if (result.user_duplicate_lookup_results[0].confidence === 'exact_email') {
          this.matchingEmail = result.email
          this.matchingDupe = result.user_duplicate_lookup_results[0]
          this.submitting = false
          this.scrollHelper.scrollTo(0, 0)
          this.analyticsService.trackError('EmailAddressAlreadyInUse')
        }

        else {
          store.nextPath = 'create-password'
          this.router.navigate([store.basePath, 'match'])
        }
      })
  }

  public emailMatchSignIn(emailMatchSignIn: HTMLFormElement): void {
    this.analyticsService.seEvent('BackToSignInClick')
    emailMatchSignIn.nativeElement.submit()
  }

  private next(store: StoreService): void {
    this.router.navigate([store.basePath, 'create-password'])
  }
}
